export default __webpack_public_path__ + "static/image-c-2526670951ecff5869c4e93b8ac9b932.png";